import { render } from "./AccessRoleSections.vue?vue&type=template&id=49a0979b&scoped=true"
import script from "./AccessRoleSections.vue?vue&type=script&lang=js"
export * from "./AccessRoleSections.vue?vue&type=script&lang=js"

import "./AccessRoleSections.vue?vue&type=style&index=0&id=49a0979b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a0979b"]])

export default __exports__